import { Box, Text } from '@factorialco/deprecated-design-system'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { PerformanceQuestionSingleLabel } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import i18n from 'modules/core/lib/i18n'

import { Answer } from '../../common/presenters'
import { ScoreAnswerCell } from '../common/AnswersTable/AnswerCell'

const TextAnswerDisplay = ({ text }: { text: string }) => {
  const { canUseRichTextEditor, loading } = useRichTextEditor()

  if (loading) return null

  if (canUseRichTextEditor) {
    return (
      <Box width="full">
        <RichTextDisplay content={text} />
      </Box>
    )
  }

  return <Text.Normal size="300">{text}</Text.Normal>
}

const ContentBox: React.FC<{ title: string; content: NonNullable<React.ReactNode> }> = ({
  title,
  content,
}) => (
  <Box gap="s16">
    <Text.Header3>{title}</Text.Header3>
    <Box width="full">{content}</Box>
  </Box>
)

const FullAnswerSidepanel: React.FC<{
  question: PerformanceQuestionSingleLabel
  answer: Answer
  onClose: () => void
}> = ({ question, answer, onClose }) => {
  return (
    <Sidepanel
      open
      title={question.title}
      onClose={onClose}
      width="wide"
      allowBackgroundInteraction
    >
      <Box gap="s32" width="full">
        {/* rating/score answer */}
        {answer.type && (
          <Box gap="s32" flexDirection="row">
            <Box padding="s2" alignItems="center" gap="s8">
              <Box>
                <ScoreAnswerCell answer={answer} height="full" />
              </Box>
              {answer.scoreLabel && (
                <Box textAlign="center" maxWidth="min-content">
                  <Text.Normal size="100" weight="medium">
                    {answer.scoreLabel.toUpperCase()}
                  </Text.Normal>
                </Box>
              )}
            </Box>
            {answer.comment ? (
              <ContentBox
                title={i18n.t('performance_process.insights.answers.comment')}
                content={<TextAnswerDisplay text={answer.comment} />}
              />
            ) : (
              <ContentBox
                title={i18n.t('performance_process.insights.answers.no_comment')}
                content={
                  <TextAnswerDisplay
                    text={i18n.t('performance_process.insights.answers.no_comment_provided')}
                  />
                }
              />
            )}
          </Box>
        )}

        {/* text answer, choice answer, integer answer */}
        {!answer.type && (
          <Box padding="s2" gap="s16">
            <Text.Header3>{i18n.t('performance_process.insights.answers.answer')}</Text.Header3>

            <TextAnswerDisplay
              text={
                answer.answerText ||
                answer.answerChoice?.join(', ') ||
                answer.answerInt?.toString() ||
                ''
              }
            />
          </Box>
        )}
      </Box>
    </Sidepanel>
  )
}

export default FullAnswerSidepanel
